import Project4 from "./Project4";
import ProjectCaseStudie from "./ProjectCaseStudie";
import ProjectGrafanaDashboards from "./ProjectGrafanaDashboards";
import ProjectPromotiefilmpje from "./ProjectPromotiefilmpje";
import ProjectRequirementAnalysis from "./projectRequirementAnalysis";
import ProjectTranslations from "./ProjectTranslations";

const projects = [
  ProjectRequirementAnalysis,
  ProjectCaseStudie,
  ProjectGrafanaDashboards,
  ProjectTranslations,
  Project4,
  ProjectPromotiefilmpje,
];

export default projects;
